export const enumPermisosItau = Object.freeze({
  RECAUDO_SERVICIOS_PUBLICOS_ITAU: 40000,
  RETIRO_ITAU: 40001,
  PAGO_PRODUCTOS_PROPIOS_ITAU: 40002,
  PAGO_OBLIGACIONES_CREDITOS_ITAU: 40004,
  DEPOSITO_ITAU: 40005
});
